export default {
    namespaced: true,
    state: () => ({
        attention : {
            show: false,
            message: '',
        }
    }),
    getters: {
        message (state) {
            return state.attention.message
        },
        show (state) {
            return state.attention.show
        }
    },
    mutations: {
        setMessage(state, payload) {
            state.attention.message = payload
        },
        setShow(state, payload) {
            state.attention.show = payload
        }
    },
    actions: {
        setMessage({ commit }, message) {
            commit('setMessage', message )
        },
        setShow({ commit }, show) {
            commit('setShow', show)
        }
    },
}
